// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3QwQb","sendOtp":"AuthorizeToLogin_sendOtp__3ZWRF"};